<template lang="pug">
  input(:id="id" :value="value" tabindex='-1')
</template>
<script>
import 'jquery-datetimepicker/jquery.datetimepicker.css'
import $ from 'jquery'
import moment from 'moment'
import 'jquery-datetimepicker/jquery.datetimepicker.js'
export default {
  name: 'datetimepicker',
  props: {
    id: {
      type: String
    },
    value: {
      type: String
    },
    minDate: {
      type: Boolean
    },
    maxDate: {
      type: Boolean
    },
    inline: {
      type: Boolean
    },
    locale: {
      type: String
    }
  },
  mounted: function() {
    var that = this
    var startDate = (this.value || new Date())
    $.datetimepicker.setDateFormatter({
      parseDate: function (date, format) {
        var d = moment(date, format)
        return d.isValid() ? d.toDate() : false
      },
      formatDate: function (date, format) {
        return moment(date).format(format)
      }
    })
    $('#' + this.id).datetimepicker({
      format: 'DD/MM/YYYY HH:mm',
      formatTime: 'HH:mm',
      formatDate: 'DD/MM/YYYY',
      inline: (this.inline || false),
      timePicker: true,
      startDate: startDate,
      minDate: (this.minDate || false),
      maxDate: (this.maxDate || false),
      onClose: function($value) {
        that.$emit('onChange', $value)
      }
    })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?1009d648